import React from "react";
import {Trans} from "react-i18next";
import {Info} from "@material-ui/icons";
import Moment from "react-moment";
import ReactTooltip from 'react-tooltip'
import "./Accounts.scss";

import {callAPI} from "../../utils/utils";
import {useGlobalModalContext} from "../../components/GlobalModal/GlobalModal";
import {useSnackbar} from "notistack";
import MenuButton from "../../components/MenuButton/MenuButton";

const AccountDomainElement = (props) => {
  const { showConfirmDialog } = useGlobalModalContext();
  const { enqueueSnackbar } = useSnackbar();
  const domain = props.domain;

  const domainActionSetDefault = () => {
    showConfirmDialog("Hauptdomain setzen", <>Soll die Domain <b>"{domain.domain}"</b> die neue Hauptdomain werden?<br/><br/>Sobald die neue Hauptdomain aktiv ist, wird sie in der Verwaltung entsprechend angezeigt. Die Umstellung kann bis zu 2 Stunden dauern.</>, {confirmButton: "Als Hauptdomain setzen"})
      .then((result) => {
        if (result) {
          callAPI("domain", "POST", "setdefault", {domain_id: domain.id }).then((data) => {
            enqueueSnackbar("Die Änderung der Hauptdomain wurde in Auftrag gegeben.", {
              variant: 'success',
            });
            window.refreshAccounts();
          });
        }
      });
  }

  const domainActionCancel = () => {
    const infoText = props.domain.cancelled ? <>Soll die Kündigung der Domain <b>"{domain.domain}"</b> rückgängig gemacht werden?</> : <>Soll die Domain <b>"{domain.domain}"</b> zum Laufzeitende gekündigt werden?</>;
    const title = props.domain.cancelled ? "Kündigung zurücknehmen" : "Domain kündigen";
    const buttonText = props.domain.cancelled ? "Kündigung zurücknehmen": "Kündigen";

    showConfirmDialog(title, infoText, {confirmButton: buttonText})
      .then((result) => {
        if (result) {
          callAPI("domain", "POST", "cancel", {domain_id: props.domain.id, state: !props.domain.cancelled }).then((data) => {
            enqueueSnackbar(props.domain.cancelled ? "Die Kündigung der Domain wurde rückgängig gemacht" : "Die Domain wurde zum Laufzeitende gekündigt", {
              variant: 'success',
            });
            window.refreshAccounts();
          });
        }
      });
  }

  const domainActionDelete = () => {
    showConfirmDialog("Domainveerlinkung löschen", <>Soll die Verlinkung der Domain <b>"{domain.domain}"</b> gelöscht werden?</>, {confirmButton: "Löschen"})
      .then((result) => {
        if (result) {
          callAPI("domain", "POST", "cancel", {domain_id: props.domain.id, state: true }).then((data) => {
            enqueueSnackbar("Die Domainweiterleitung wurde gelöscht", {
              variant: 'success',
            });
            window.refreshAccounts();
          });
        }
      });
  }

  /** PREPARE MENU ITEMS **/

  let menuItems = [
    {caption:'Als Hauptdomain setzen', action: domainActionSetDefault, enabled: true},
  ];

  if (domain.type === "domain")
    menuItems.push({caption: domain.cancelled ? 'Kündigung zurücknehmen' : 'Domain kündigen', action: domainActionCancel, enabled: true});

  if (domain.type === "link")
    menuItems.push({caption: "Verlinkung löschen", action: domainActionDelete, enabled: true});

  return (
    <>
      <div className={'account-domain-element'}>
        <div className={'col-domain'}><a target="_blank" rel="noreferrer" href={'https://www.' + domain.domain}>{domain.domain}</a></div>
          <div className={'col-date'}>
            {domain.type === 'link' ? "Verlinkung" : <>
              <Moment format="DD.MM.YYYY" unix>{domain.end_date}</Moment> &nbsp;
              {domain.cancelled && <Info
                style={{width: 16, height: 16, position: 'absolute', top: -3, color: 'rgba(255, 75, 75, 1)'}}
                data-tip={'Diese Domain wurde zum Laufzeitende gekündigt'}/>
              }
            </>}
          </div>
          <div className={'col-status ' + (domain.in_progress ? 'progress' : domain.http_status ? 'online' : 'offline')}>
            {domain.in_progress ? <Trans>Domains.Element.StatusInProgress</Trans> : domain.http_status ? <Trans>Domains.Element.StatusOnline</Trans> : <Trans>Domains.Element.StatusOffline</Trans>}
          </div>
        <div className={'col-https ' + (domain.https_status ? 'online' : domain.http_status ? 'progress' : 'offline')}>
          {domain.https_status ? <Trans>Domains.Element.HttpsOnline</Trans> : (domain.http_status ? <Trans>Domains.Element.HttpsInProgress</Trans> : <Trans>Domains.Element.HttpsOffline</Trans>)}
        </div>
          <div style={{position:'relative',flexGrow: 1}}>
            {!props.disableMenu && <MenuButton items={menuItems}/>}
          </div>
        </div>
      < ReactTooltip/>
    </>
  );
}

export default AccountDomainElement;